const {
    BROKER_CUSTOM_WALLET_CONTRACT_FUNDS_TYPE,
    BROKER_CUSTOM_WALLET_CONTRACT_VALORES_TYPE,
    BROKER_CUSTOM_WALLET_CONTRACT_PLANS_TYPE,
} = require('../constants/index');

const mergeInWallet = (state, idPortfolioAccount, mergeMethod) => {
    const mappedWallets = state.get('customWallets').map(wallet => {
        if (wallet.get('idPortfolioAccount') === idPortfolioAccount) {
            return mergeMethod(wallet);
        }

        return wallet;
    });

    return state.merge({
        customWallets: mappedWallets
    });
}

const parsePortfolioDTO = wallet => {
    return {
        idPortfolioAccount: wallet.idPortfolioAccount, // Id
        userId: wallet.userId ? wallet.userId.trim() : '',
        idTypePortfolioAccount: wallet.idTypePortfolioAccount,
        typePortfolioAccount: wallet.typePortfolioAccount,
        idCartera: wallet.idCartera,
        portfolioId: wallet.portfolioId,
        descriptionPortfolioAccount: wallet.descriptionPortfolioAccount ? wallet.descriptionPortfolioAccount.trim() : '',
        count: wallet.count,
        defaultView: false
    }
}

const parseContractDTO = (contract, enabled = false) => {
    return {
        userId: contract.userId ? contract.userId.trim() : '',
        idTypePortfolioAccount: contract.idTypePortfolioAccount,
        typePortfolioAccount: contract.typePortfolioAccount,
        idPortfolioAccount: contract.idPortfolioAccount,
        idCartera: contract.idCartera ? contract.idCartera : '-', // Id
        portfolioId: contract.portfolioId,
        portfolioIdFormatted: contract.portfolioIdFormatted,
        name: contract.descriptionPortfolioAccount && contract.descriptionPortfolioAccount.trim() ? contract.descriptionPortfolioAccount.trim() : '-',
        enabled: contract.enabled || enabled,
        personalizable: contract.personalizable,
        tipoIntervencion: contract.tipoIntervencion
    };
}

const filterPgContracts = (pgContracts, vxcContracts) => {
    const cleanPgContracts = pgContracts.filter((pgContract) => {
        return !!pgContract.get('elements').size
    });
    const filteredResponse = vxcContracts.filter((vxcContract) => {
        return cleanPgContracts.find((pgContract)=> {
            return pgContract.get('contract').indexOf(vxcContract.portfolioId) != -1;
        })
    });

    return filteredResponse;
}


// TODO: this should change when the contract type comes
// from service
const parseContracts = (contracts, enabled, enabledProducts) => {
    const enabledProductsList = enabledProducts;
    let parsedContracts = [];
    for (const contract of contracts) {
        const parsedContract = parseContractDTO(contract, enabled);
        const productFromPortfolioId = parsedContract.portfolioId.match(/(\d{3})(?=\d{7}$)/g);
        let type;
        switch (true) {
            case /(?:400|434)\d{7}$/.test(parsedContract.portfolioId):
                type = BROKER_CUSTOM_WALLET_CONTRACT_VALORES_TYPE;
                break;
            case enabledProductsList.includes(productFromPortfolioId[0]):
                type = BROKER_CUSTOM_WALLET_CONTRACT_FUNDS_TYPE;
                break;
            case /(?:305|312)\d{7}$/.test(parsedContract.portfolioId):
                type = BROKER_CUSTOM_WALLET_CONTRACT_PLANS_TYPE;
                break;
            default:
                continue;
        }

        parsedContract.portfolioType = type;

        if (contract.personalizable) {
            parsedContracts = [parsedContract, ...parsedContracts];
        } else {
            parsedContracts = [...parsedContracts, parsedContract];
        }
    }
    return parsedContracts;
};

module.exports = {
    parsePortfolioDTO,
    parseContractDTO,
    parseContracts,
    mergeInWallet,
    filterPgContracts,
};